import { useQuery } from "@tanstack/react-query";

const { default: apiClient } = require("lib/api-client");

// Dues Transaction data...

const getDuesTransaction = async ({ clientCode, AllDues }) => {
  const response = await apiClient.post(`/api/v9/myBinnys/getDuesTransaction`, {
    clientCode,
    AllDues,
  });
  return response.data?.data;
};

export const useDuesTransaction = ({ clientCode, AllDues = false, isLedgerPage }) => {
  return useQuery({
    queryKey: ["duesTransaction", clientCode, AllDues],
    queryFn: () => getDuesTransaction({ clientCode, AllDues }),
    enabled: !isLedgerPage,
  });
};

// Due Transaction Designs

const getSingleDuesItem = async (transactionNo) => {
  const response = await apiClient.get(`/api/v9/myBinnys/getSingleDuesItems/${transactionNo}`);
  return response?.data?.data;
};

// export const useSingleDuesItem = (transactionNo) => {
//   return useQuery({
//     queryKey: ["singleDuesItem", transactionNo],
//     queryFn: () => getSingleDuesItem(transactionNo),
//     enabled: !!transactionNo,
//     retry: false,
//   });
// };

// Ledger Transaction data...

const getLedgerTransactionAndSummary = async ({ searchBy = "", clientCode, financialYear }) => {
  const response = await apiClient.post(`/api/v9/myBinnys/getLedgerTransacationAndSummary`, {
    searchBy,
    clientCode,
    financialYear,
  });
  return response.data;
};

export const useLedgerTransaction = ({ clientCode, searchBy = "", isLedgerPage, financialYear }) => {
  return useQuery({
    queryKey: ["ledgerTransaction", clientCode, searchBy, financialYear],
    queryFn: () => getLedgerTransactionAndSummary({ searchBy, clientCode, financialYear }),
    enabled: !!isLedgerPage,
    retry: false,
  });
};

//When user select left design
export const fetchJewelTransId = async (transactionNo) => {
  try {
    const res = await apiClient(`/api/v9/myBinnys/getDueBillingSummary?transactionNo=${transactionNo}`);
    return res?.data?.data;
  } catch (error) {
    if (error?.response?.data?.status == 500) {
      return {};
    }
  }
};

export const useJewelAndDesign = (transactionNo) => {
  return useQuery({
    queryKey: ["jewelAndDesign", transactionNo],
    queryFn: async () => {
      if (!transactionNo) return { jewelData: null, designData: [] };

      const jewelData = await fetchJewelTransId(transactionNo);
      const JewelTransId = jewelData?.JewelTransId;
      const designData = jewelData?.JewelTransId ? await getSingleDuesItem(jewelData.JewelTransId) : [];

      return { designData, JewelTransId };
    },
    enabled: !!transactionNo,
    retry: 0,
  });
};
